import React, { useMemo } from 'react';
import { useLoggedInUser, useFeatureFlags } from '@tcc/shared-data-lib';
import { importFromS3 } from '../../utils/importFromS3';
import { useUserLoggedInConfigs, useFeatureFlagsConfigs } from '../../utils/sharedData';

type Props = {
  isPluginEnabled?: boolean;
};

const S3Plugin = React.lazy(() => importFromS3('tcc-programs-plugin'));

export const ProgramsPluginContainer: React.FC<Props> = () => {
  const { user } = useLoggedInUser(useUserLoggedInConfigs);
  const { featureFlags } = useFeatureFlags(useFeatureFlagsConfigs(user));
  const useModuleFederation = featureFlags['web.programs-plugin.module-federation'];

  const ProgramsPlugin = useMemo(() => {
    if (useModuleFederation) {
      return React.lazy(() => import('programsPlugin/ProgramsPlugin'));
    }
    return S3Plugin;
  }, [useModuleFederation]);

  return <ProgramsPlugin />;
};
